<template>
    <div>
        <Newsletter v-for="newsletterInfo in activeNewsletters" :data="newsletterInfo" />
    </div>
</template>
<script>
import dynamicLocalization from "@/mixins/dynamic-localization";
import Newsletter from "./Newsletter.vue";

const activeNewsletters = [require("./2024.04/data.yml"), require("./2024.03/data.yml")];

export default {
    mixins: [dynamicLocalization],
    components: { Newsletter },
    data() {
        return {
            activeNewsletters,
        };
    },
};
</script>
<i18n src="./i18n.json" />
<i18n src="@/locales/global.json" />
